import React from "react";
import styles from "./style.module.scss";
import SkeletonLoader from "../../../../components/skeleton-loader";

const StatCardSkeleton = () => (
  <div className={styles.stat_card}>
    <div className={styles.stat_content}>
      <SkeletonLoader
        variant="rectangular"
        width="65%"
        height={12}
        className={styles.skeleton_line}
      />
      <SkeletonLoader
        variant="rectangular"
        width="45%"
        height={24}
        className={styles.skeleton_line}
      />
    </div>
  </div>
);

const ApprovalStats = ({ loading, stats }) => {
  if (loading) {
    return (
      <div className={styles.stats_container}>
        {Array.from({ length: 4 }).map((_, i) => (
          <StatCardSkeleton key={`stat-skel-${i}`} />
        ))}
      </div>
    );
  }

  return (
    <div className={styles.stats_container}>
      <div className={styles.stat_card}>
        <div className={styles.stat_content}>
          <div className={styles.header}>Total Powerapps</div>
          <div className={styles.amount}>{stats.total_powerapps || 0}</div>
        </div>
      </div>

      <div className={styles.stat_card}>
        <div className={styles.stat_content}>
          <div className={styles.header}>Total Approvals</div>
          <div className={styles.amount}>{stats.total_approvals || 0}</div>
        </div>
      </div>

      <div className={styles.stat_card}>
        <div className={styles.stat_content}>
          <div className={styles.header}>Approved</div>
          <div className={styles.amount}>{stats.summary?.approved || 0}</div>
        </div>
      </div>

      <div className={styles.stat_card}>
        <div className={styles.stat_content}>
          <div className={styles.header}>Declined</div>
          <div className={styles.amount}>{stats.summary?.declined || 0}</div>
        </div>
      </div>
    </div>
  );
};

export default ApprovalStats;
